import {handleAPI, API_VERSION_ONE} from '../../utils/apiUtils';

export function passwordUpdate(data){
  const url = `/${API_VERSION_ONE}/passwords/change`;
  const method = "POST"
  return {
    type: 'PASSWORD_UPDATE',
    payload: handleAPI(url,{},method, {password: {...data}})
  }
}

export function passwordReset(data){
  const url = `/${API_VERSION_ONE}/passwords/reset/`;
  const method = "POST"
  return {
    type: 'PASSWORD_RESET',
    payload: handleAPI(url,{},method, {user: {...data}})
  }
}

export function passwordForgot(data){
  const url = `/${API_VERSION_ONE}/passwords/forgot`;
  const method = "POST"
  return {
    type: 'PASSWORD_FORGOT',
    payload: handleAPI(url,{},method, {password: {...data}})
  }
}